import clsx from 'clsx'
import {toAbsoluteUrl} from '../../../helpers'
import {HeaderUserMenu, ThemeModeSwitcher} from '../../../partials'
import {toast} from 'react-toastify'
import axios from '../../../../Helpers/Api_instance'
import {useAuth} from '../../../../app/modules/auth'

const itemClass = 'ms-1 ms-md-4'
const userAvatarClass = 'symbol-35px'
const Navbar = () => {
  const {currentUser, setCurrentUser} = useAuth()

  const updateBranch = async () => {
    try {
      const res = await axios.patch(`/auth/branch/status`, {
        status: currentUser.branches[0].status == 'Active' ? 'Inactive' : 'Active',
      })
      if (res && res.data) {
        toast.success('Branch status updated successfully')
        setCurrentUser({
          ...currentUser,
          branches: [
            {
              ...currentUser.branches[0],
              status: currentUser.branches[0].status == 'Active' ? 'Inactive' : 'Active',
            },
          ],
        })
      }
    } catch (error) {
      toast.error('Failed to update branch status')
    }
  }

  return (
    <div className='app-navbar flex-shrink-0 '>
      <div className={clsx('app-navbar-item')}>
        <div className='form-check form-switch'>
          <input
            className={
              currentUser.branches[0].status == 'Active'
                ? 'form-check-input bg-success'
                : 'form-check-input bg-danger'
            }
            type='checkbox'
            id='flexSwitchCheckChecked'
            checked={currentUser.branches[0].status == 'Active'}
            onClick={() => {
              // updateStore()
              updateBranch()
            }}
          />
        </div>
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <img src={toAbsoluteUrl('/media/logos/Admin_logo.png')} alt='' />
        </div>
        <HeaderUserMenu />
      </div>
    </div>
  )
}

export {Navbar}
